import { render, staticRenderFns } from "./MobileStory.vue?vue&type=template&id=ba7c55bc&scoped=true&"
import script from "./MobileStory.vue?vue&type=script&lang=js&"
export * from "./MobileStory.vue?vue&type=script&lang=js&"
import style0 from "./MobileStory.vue?vue&type=style&index=0&id=ba7c55bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7c55bc",
  null
  
)

export default component.exports